import 'nodelist-foreach-polyfill';

export default function (container) {
  container.querySelectorAll('[data-upload-file]').forEach((wrapper) => {
    const input = wrapper.querySelector('[type="file"]');
    const text = wrapper.querySelector('.upload-file__text');
    input.addEventListener('change', (e) => {
      const { files } = e.target;
      if (files.length !== 0) {
        const t = [];
        for (let i = 0; i < files.length; i++) {
          t.push(files[i].name);
        }
        text.textContent = t.join(', ');
      }
    });
  });
}
